import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IFileEntity } from '@app/pages/cmms/interfaces/files.interfaces';
import { AuPipesModule } from '@app/shared/pipes/au-pipes.module';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'file-metadata-table',
	templateUrl: './file-metadata-table.component.html',
	styleUrls: ['./file-metadata-table.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		AuPipesModule,
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		NgxTolgeeModule,
	],
})
export class FileMetadataTableComponent {
	@Input() fileData: IFileEntity;

	@Output() downloadPressed = new EventEmitter<void>();
	@Output() replacePressed = new EventEmitter<void>();

	download($event) {
		$event.stopPropagation();
		this.downloadPressed.emit();
	}

	replace($event) {
		$event.stopPropagation();
		this.replacePressed.emit();
	}

	getFormatFromContentType(contentType: string): string {
		return contentType.split('/').pop();
	}
}
